import { createAsyncThunk } from "@reduxjs/toolkit";
import { getSymbol } from "../../api/request/dashboard/dashboard";
import { setChartSymbol } from "../Slices/watchList";

export const fetchSymbols = createAsyncThunk('Symbols/get', async (_, { getState, dispatch }) => {
    console.log("Hello ")
    const clientId = getState().user?.userDetail?.id
    const chartSymbols = getState().watchlist.chartSymbols;
    try {
        const { data } = await getSymbol(clientId)
        const rowData = {}

        data?.forEach((update, index) => {
            if (index <= 4) {
                !chartSymbols[index] && dispatch(setChartSymbol([index, update?.id]))
            }
            if (chartSymbols.includes(update?.id)) {
                rowData[update?.id] = { ...update };
            }
        });
        data?.forEach((update) => {
            rowData[update?.id] = { ...update };
        });
        return rowData
    } catch (err) {
        return {};
    }
})